import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../service/indentifyDevice";
import LoginIdForm, { ILoginIdFormProps } from "../forms/loginIdForm";
import logo from "../../../assets/images/logo_white.jpg"

export interface ILoginIdScreenProps extends ILoginIdFormProps {
	onClose?: () => void;
}

const LoginIdScreen: React.FC<ILoginIdScreenProps> = (props) => {
	return (
		<LoginPopup
			leftHeaderContent={!DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			centerHeaderContent={DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			onClose={props.onClose}
			className="login_scrn"
		>
			<LoginIdForm {...props} />
		</LoginPopup>
	);
};

export default LoginIdScreen;
